/* eslint-disable react/no-string-refs */
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { PanelBody, PanelButtonLink, PanelHeading } from '../../elements';

interface IPotree3dProps {
    objectId: string;
    surveyId: string;
    isAnnotationsDefaultVisible: boolean;
}

function openInWindow(url: string) {
    window.open(url, undefined, 'height=600,width=800,status=yes,resizable=yes,toolbar=no,menubar=no,location=no');
}

export function Potree3D(props: IPotree3dProps) {
    const translate = useTranslate();

    const potreeVersion = `/assets/pointcloud/viewer/v18.html`;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const potreeUrl = `${potreeVersion}?objectId=${props.objectId}&surveyId=${props.surveyId}&annotationsDefaultVisible=${props.isAnnotationsDefaultVisible}`;

    return (
        <div className="panel " id="3DModel">
            <PanelHeading text={translate('survey.3dModel')} icon="fa fa-image">
                <PanelButtonLink
                    onClick={() => openInWindow(`${potreeUrl}&hideSidebarTools=false`)}
                    small={true}
                    primary={false}
                    icon="fa fa-external-link"
                    text={translate('survey.open3dViewer')}
                />
            </PanelHeading>

            <PanelBody whiteBackground={true}>
                <iframe src={`${potreeUrl}&hideSidebarTools=true`} scrolling="no" title="Pointcloud" width="100%" height={400} frameBorder={0} />
            </PanelBody>
        </div>
    );
}
